import { useContext } from 'react';
import FieldContext from '../../../FieldContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import FieldNameWrapper from './FieldNameWrapper';
import StyledFieldName from './StyledFieldName';
import FieldInfo from './FieldInfo';
import SectionContentGroupContext from '../../../../Section/SectionContentGroupContext';

const FieldName = () => {
  const sectionContentGroup = useContext(SectionContentGroupContext);
  const field = useContext(FieldContext);

  if (!field.name) {
    return null;
  }

  const isInRightSectionContentGroup =
    sectionContentGroup === ContentGroupType.RIGHT;

  return (
    <FieldNameWrapper secondary={isInRightSectionContentGroup}>
      <StyledFieldName bold={!isInRightSectionContentGroup}>
        {field.name}
      </StyledFieldName>
      {field.info && <FieldInfo />}
    </FieldNameWrapper>
  );
};

export default FieldName;
